export default __webpack_public_path__ + "static/media/shubh_white_paper.506f6742.pdf";